import SkeletonWrapper from './skeleton-wrapper'

export default SkeletonWrapper
